






















import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
    props: {
        search: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            loading: false,
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                { text: 'Pickup Address', value: 'pickupAddress', sortable: false },
                {
                    text: 'Dropoff Address',
                    value: 'dropoffAddress',
                    sortable: false,
                },
            ],
            data: [],
        };
    },
    computed: {
        ...mapState('offices', ['corpOffices']),
    },
    methods: {
        onRowSelect(row: any, rowDetails: any) {
            rowDetails.select(true);
            this.$emit('onRowSelect', row);
        },
    },
});
